import { useState } from 'react';
import { Batches } from '../lib/data';

const C = {
  bg: '#070B10', surface: '#0D1520', border: '#1A2A40',
  accent: '#00D4FF', text: '#E8F0F8', muted: '#5A7A99',
  mono: "'JetBrains Mono','Fira Mono',monospace",
  sans: "'Inter',system-ui,sans-serif",
};

export default function BatchesTab({ compounds, batches, setBatches }) {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ compound_id: '', batch_number: '', supplier: '', purchase_date: '', cost: '' });

  
const add = async () => {
  console.log('Add clicked, form:', form);
  if (!form.compoundName.trim() || !form.batch_number.trim()) {
    console.log('Missing fields');
    return;
  }
  console.log('Saving batch...');
  try {
    const added = await Batches.add({
      compound_id: null,
      batch_number: form.batch_number,
      supplier: form.supplier,
      purchase_date: form.purchase_date,
      cost: form.cost ? parseFloat(form.cost) : null,
      notes: form.compoundName, // Store compound name here
    });
    console.log('Batch saved:', added);
    setBatches([...batches, added]);
    setShowForm(false);
    setForm({ compound_id: '', compoundName: '', batch_number: '', supplier: '', purchase_date: '', cost: '' });
  } catch (err) {
    console.error('Failed to add batch:', err);
  }
};

  const del = async (id) => {
    try {
      await Batches.remove(id);
      setBatches(batches.filter(b => b.id !== id));
    } catch (err) {
      console.error('Failed to delete:', err);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div style={{ fontFamily: C.mono, fontSize: 11, color: C.muted, letterSpacing: '0.1em' }}>INVENTORY</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: C.text }}>{batches.length} batch{batches.length !== 1 ? 'es' : ''}</div>
        </div>
        <button onClick={() => setShowForm(true)} style={{ padding: '8px 16px', background: C.accent, color: C.bg, border: 'none', borderRadius: 6, fontFamily: C.sans, fontWeight: 600, cursor: 'pointer' }}>+ Add</button>
      </div>

    {batches.map(b => (
  <div key={b.id} style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 8, padding: 16 }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600, fontSize: 15, color: C.text }}>{b.notes || 'Unknown'}</div>
        <div style={{ fontSize: 11, color: C.muted, marginTop: 6, lineHeight: 1.6 }}>
          <div>Batch: <span style={{ color: C.accent, fontFamily: C.mono }}>{b.batch_number}</span></div>
          {b.supplier && <div>Supplier: {b.supplier}</div>}
          {b.purchase_date && <div>Purchased: {new Date(b.purchase_date).toLocaleDateString()}</div>}
          {b.cost && <div>Cost: ${b.cost.toFixed(2)}</div>}
        </div>
      </div>
      <button onClick={() => del(b.id)} style={{ padding: '4px 8px', background: '#FF4D6A', color: C.bg, border: 'none', borderRadius: 4, fontWeight: 600, cursor: 'pointer', fontSize: 12 }}>✕</button>
    </div>
  </div>
))}

{showForm && (
  <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 8, padding: 16 }}>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {console.log('Available compounds:', compounds)}
      <input 
  type="text" 
  placeholder="Compound name" 
  value={form.compoundName || ''}
  onChange={e => setForm({...form, compoundName: e.target.value})}
  style={{ padding: '8px 12px', background: C.bg, border: `1px solid ${C.border}`, borderRadius: 6, color: C.text, fontFamily: C.sans }}
/>

    

            <input type="text" placeholder="Batch #" value={form.batch_number} onChange={e => setForm({...form, batch_number: e.target.value})} style={{ padding: '8px 12px', background: C.bg, border: `1px solid ${C.border}`, borderRadius: 6, color: C.text, fontFamily: C.sans }} />
            <input type="text" placeholder="Supplier" value={form.supplier} onChange={e => setForm({...form, supplier: e.target.value})} style={{ padding: '8px 12px', background: C.bg, border: `1px solid ${C.border}`, borderRadius: 6, color: C.text, fontFamily: C.sans }} />
            <input type="date" value={form.purchase_date} onChange={e => setForm({...form, purchase_date: e.target.value})} style={{ padding: '8px 12px', background: C.bg, border: `1px solid ${C.border}`, borderRadius: 6, color: C.text, fontFamily: C.sans }} />
            <input type="number" placeholder="Cost ($)" value={form.cost} onChange={e => setForm({...form, cost: e.target.value})} style={{ padding: '8px 12px', background: C.bg, border: `1px solid ${C.border}`, borderRadius: 6, color: C.text, fontFamily: C.sans }} />
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowForm(false)} style={{ padding: '8px 16px', background: 'transparent', color: C.accent, border: `1px solid ${C.border}`, borderRadius: 6, cursor: 'pointer' }}>Cancel</button>
              <button onClick={add} style={{ padding: '8px 16px', background: C.accent, color: C.bg, border: 'none', borderRadius: 6, fontWeight: 600, cursor: 'pointer' }}>Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}